import React from 'react';
import PropTypes from 'prop-types';

import { useInjectSaga } from '../../../../redux/injectSaga';
import { RESTART_ON_REMOUNT } from '../../../../redux/sagaInjectors';
import consentSaga from '../../../../redux/surveys/sagas/consent-saga';
import Program from '../../../Program';
import Loader from '../../Loader';
import Popup from '../../Popup';

const ProgramPopupContent = ({
  title,
  onClose,
  surveysLoading,
  targetFormLoading,
  program,
  date,
  contextStore,
  children,
}) => {
  useInjectSaga({
    key: 'consentSaga',
    saga: consentSaga,
    mode: RESTART_ON_REMOUNT,
  });

  return (
    <Popup opened onClose={onClose} title={title} width="medium" strictClose>
      <If condition={!date}>
        <Program
          program={program}
          className="mb3"
          store={contextStore}
          onLeave={onClose}
        />
      </If>
      <Choose>
        <When condition={!surveysLoading && !targetFormLoading}>
          {children}
        </When>
        <Otherwise>
          <Loader />
        </Otherwise>
      </Choose>
    </Popup>
  );
};

ProgramPopupContent.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  surveysLoading: PropTypes.bool,
  targetFormLoading: PropTypes.bool,
  program: PropTypes.object,
  date: PropTypes.string,
  contextStore: PropTypes.object,
  children: PropTypes.node,
};

export default ProgramPopupContent;



// WEBPACK FOOTER //
// ./src/components/common/ProgramPopup/ProgramPopupContent/index.jsx